module.exports = __webpack_public_path__ + "static/media/message.2fb83beb.svg";